(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["acs-secondary-split"] && !Shopify.designMode) return;
  try {
    
// No JS required

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["collection-rich-article"] && !Shopify.designMode) return;
  try {
    
/* Smooth expand/collapse + section-level options for FAQ; supports FAQ groups */
(function () {
  try {
    var root = document.querySelector('[id^="collection-rich-article-"]');
    if (!root) return;

    var faqs = Array.prototype.slice.call(root.querySelectorAll('.crab-faq'));

    // ✅ get Liquid values safely from data-attributes
    var startCollapsed = root.dataset.startCollapsed === "true";
    var accordion = root.dataset.accordion === "true";

    function setHeight(det, open) {
      var wrap = det.querySelector('.faq-a-wrap');
      var summary = det.querySelector('summary.faq-q');
      if (!wrap || !summary) return;
      wrap.style.maxHeight = open ? wrap.scrollHeight + 'px' : '0px';
      summary.setAttribute('aria-expanded', open ? 'true' : 'false');
    }

    function closeOthers(current) {
      var group = current.closest('.crab-faq-group') || root;
      Array.prototype.slice.call(group.querySelectorAll('.crab-faq')).forEach(function (det) {
        if (det !== current && det.open) {
          det.open = false;
          setHeight(det, false);
        }
      });
    }

    // Initialize
    faqs.forEach(function (det) {
      if (startCollapsed) det.open = false;
      setHeight(det, det.open);
      det.addEventListener('toggle', function () {
        setHeight(det, det.open);
        if (accordion && det.open) closeOthers(det);
      });
    });

    // keep height accurate on resize
    if ('ResizeObserver' in window) {
      var ro = new ResizeObserver(function () {
        faqs.forEach(function (det) {
          if (det.open) setHeight(det, true);
        });
      });
      faqs.forEach(function (det) {
        var wrap = det.querySelector('.faq-a-wrap');
        if (wrap) ro.observe(wrap);
      });
    } else {
      window.addEventListener('resize', function () {
        faqs.forEach(function (det) {
          if (det.open) setHeight(det, true);
        });
      });
    }
  } catch (e) {}
})();


  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["custom_banner_columns_grouped"] && !Shopify.designMode) return;
  try {
    
  // Load Flickity if not already loaded
  if (window.innerWidth < 768 && typeof Flickity === 'undefined') {
    var flickityScript = document.createElement('script');
    flickityScript.src = 'https://cdn.jsdelivr.net/npm/flickity@2/dist/flickity.pkgd.min.js';
    document.head.appendChild(flickityScript);

    var flickityStyles = document.createElement('link');
    flickityStyles.rel = 'stylesheet';
    flickityStyles.href = 'https://cdn.jsdelivr.net/npm/flickity@2/dist/flickity.min.css';
    document.head.appendChild(flickityStyles);

    flickityScript.onload = function () {
      new Flickity('.custom-banner-slider-inner', {
        cellAlign: 'left',
        contain: true,
        pageDots: true,
        prevNextButtons: false,
        wrapAround: true
      });
    };
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
